import { render, staticRenderFns } from "./newUserCard.vue?vue&type=template&id=1335d4e1"
import script from "./newUserCard.vue?vue&type=script&lang=ts"
export * from "./newUserCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports